import { markAsCompleted } from './_core'

const sameUrl = (url01, url02) => {
	try {
		const { hostname, pathname } =  new URL(url01)
		const { hostname:currentLocation, pathname:currentPathname } = new URL(url02)

		const _pathname = (pathname||'').replace(/(^\/|\/$)/g,'').toLowerCase()
		const _currentPathname = (currentPathname||'').replace(/(^\/|\/$)/g,'').toLowerCase()

		return hostname == currentLocation && _pathname == _currentPathname
	} catch(err) {
		console.error(err.stack||err.message)
		return false
	}
}

/**
 * 
 * @param	{Object}	input	
 * @param	{String}	input.id
 * @param	{String}	input.url	
 * @param	{Function}	next	
 * @param	{Object}	context	
 * 
 * @return	{Void}
 */
export default function track(input, next, context) {
	try {
		const { debug } = context || {}
		const { id, url } = input||{}
		if (debug)
			console.log(`INFO - Start tracking 'browse' event (id: ${id}, url: ${url})`)
		if (!url) {
			markAsCompleted(id, next, context)
			return
		}

		if (sameUrl(url, window.location.href))
			markAsCompleted(id, next, context)
		else {
			const apply = (target, thisArg, args) => {
				const [,,newPathname] = args||[]
				const { origin, pathname } = new URL(window.location.href)
				const nextPath = (pathname||'').split('/').slice(0,-1).join('/')

				const nextUrlStr = /^\//.test(newPathname||'')
					? `${origin}${newPathname}`
					: `${origin}${nextPath}/${newPathname}`

				const nextUrl = new URL(nextUrlStr).toString()
				if (sameUrl(url, nextUrl))
					markAsCompleted(id, next, context)

				return target.apply(thisArg, args)
			}
			window.history.pushState = new Proxy(window.history.pushState, { apply })
			window.history.replaceState = new Proxy(window.history.replaceState, { apply })
		}
	} catch(err) {
		console.error(`ERROR - Failed to track 'browse' instruction. Details: ${err.stack||err.message}`)
	}
}